'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.betagroups.add', [])
  .controller('BetaGroupsAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betagroups/add/index.js